// Autoren-FAQ für LacLive - kuratiert aus dem persönlichen FAQ.
// Bewusst NICHT enthalten (Redundanz mit SharedFaq/FoodBone):
//  - "Was ist Laktoseunverträglichkeit eigentlich?"
//  - "Ist Laktoseunverträglichkeit dasselbe wie eine Milchallergie?"
//  - "Warum vertragen manche fermentierte Milchprodukte besser?"

export const faqCategories = [
  "Probiotika",
  "Milch & Alltag",
  "Darm & Regeneration",
  "Praxis & Programm",
];

export const faqItems = [
  // -------- Probiotika --------
  {
    cat: "Probiotika",
    q: "Können Probiotika bei Laktoseunverträglichkeit helfen?",
    a: "Ja, bestimmte Stämme können Symptome lindern, indem sie bakterielle β-Galaktosidase bereitstellen, die Laktose bereits im Darm aufspaltet, und indem sie die Darmflora so verändern, dass Laktose effizienter und mit weniger Gas fermentiert wird.",
  },
  {
    cat: "Probiotika",
    q: "Welche Probiotika-Stämme sind am besten belegt?",
    a: "Häufig genannte, gut untersuchte Gattungen/Stämme sind Lactobacillus acidophilus (z. B. DDS-1), Bifidobacterium longum, Bifidobacterium animalis subsp. lactis und Streptococcus thermophilus. Die Wirkung ist stammspezifisch - nicht jedes 'Laktobazillus'-Produkt wirkt gleich.",
  },
  {
    cat: "Probiotika",
    q: "Wie genau wirken Probiotika bei Laktose?",
    a: "Mindestens drei Mechanismen werden beschrieben: (1) Direkte Enzymaktivität - Bakterien produzieren β-Galaktosidase und spalten Laktose. (2) Mikrobiom-Anpassung - sie fördern lactose-fermentierende Bakterien (z. B. Bifidobakterien), die Laktose 'ruhiger' verarbeiten. (3) Günstigere Fermentationsmuster - weniger gasbildende Prozesse, mehr kurzkettige Fettsäuren (SCFA), die die Darmbarriere stärken.",
  },
  {
    cat: "Probiotika",
    q: "Heilen Probiotika die Laktoseunverträglichkeit?",
    a: "Nein, sie stellen die körpereigene Laktase-Produktion nicht wieder her. Sie können aber die Symptome deutlich reduzieren und die Toleranz gegenüber kleinen Laktosemengen verbessern, solange sie regelmäßig genommen werden.",
  },
  {
    cat: "Probiotika",
    q: "Wie lange dauert es, bis Probiotika wirken?",
    a: "Viele Studien zeigen Effekte innerhalb von 2-8 Wochen regelmäßiger Einnahme. Manche Menschen spüren schon nach 1-2 Wochen weniger Blähungen oder einen ruhigeren Stuhlgang.",
  },
  {
    cat: "Probiotika",
    q: "Kann ich Probiotika einfach so nehmen oder gibt es Risiken?",
    a: "Für die meisten gesunden Erwachsenen sind die gängigen Probiotika-Stämme sicher. Bei schwerer Immunschwäche, kritischer Erkrankung oder bestimmten Vorerkrankungen sollte die Einnahme aber mit dem behandelnden Arzt abgesprochen werden.",
  },

  // -------- Milch & Alltag --------
  {
    cat: "Milch & Alltag",
    q: "Muss ich während der Probiotika-Therapie komplett auf Milch verzichten?",
    a: "Nicht unbedingt. Oft hilft ein schrittweises Vorgehen: Start mit laktosearmen/fermentierten Produkten (Joghurt, alter Käse), kleine Mengen über den Tag verteilt statt großer Portionen, und beobachten, was individuell gut vertragen wird. Probiotika können diese 'Gewöhnung' unterstützen, indem sie die colonic adaptation fördern.",
  },
  {
    cat: "Milch & Alltag",
    q: "Soll ich bei Laktoseunverträglichkeit komplett auf Milchprodukte verzichten?",
    a: "Nicht zwingend. Viele Menschen vertragen kleine Mengen oder bestimmte Produkte (fermentiert, lange gereift). Ein kompletter Verzicht kann unnötig Nährstoffe (Calcium, hochwertiges Protein, bestimmte Vitamine) kosten, die für Regeneration und Muskelaufbau wichtig sind.",
  },
  {
    cat: "Milch & Alltag",
    q: "Welche Lebensmittel eignen sich als 'darmfreundliche Brücke'?",
    a: "Gut passende Beispiele: Naturjoghurt mit lebenden Kulturen (oft besser vertragen, liefert Protein + Probiotika), laktosearme/laktosefreie Milchprodukte (wenn große Mengen sonst Probleme machen), fermentierte Lebensmittel (z. B. bestimmte Käsesorten, ggf. auch nicht-milchbasierte wie Sauerkraut, Kimchi - je nach individueller Verträglichkeit) und ballaststoffreiche Beilagen (Vollkorn, Hülsenfrüchte in verträglichen Mengen), die das Mikrobiom füttern. Ziel: Den Darm ruhig halten, aber gleichzeitig ausreichend Energie und Protein für Regeneration bieten.",
  },
  {
    cat: "Milch & Alltag",
    q: "Ich habe Angst, dass Milchprodukte meine Verdauung wieder verschlechtern.",
    a: "Das ist verständlich. Der Trick liegt in Dosierung und Auswahl: Start mit sehr kleinen Portionen, Bevorzugung fermentierter/laktosearmer Varianten, Kombination mit Probiotika. Beobachten statt verbieten - ein Ernährungstagebuch hilft, Muster zu erkennen. So kannst du testen, ob und welche Milchprodukte dir guttun, ohne massive Symptome zu riskieren.",
  },

  // -------- Darm & Regeneration --------
  {
    cat: "Darm & Regeneration",
    q: "Warum sollte ich mich für meinen Darm interessieren, wenn es mir 'nur' um Laktose geht?",
    a: "Weil der Darm mehr ist als eine Verdauungsröhre: Er ist eine zentrale Schnittstelle zwischen Ernährung, Immunsystem und Stoffwechsel. Eine gestörte Darmbarriere und ein dysbalanciertes Mikrobiom können niedriggradige Entzündungen fördern, die wiederum den gesamten Energiestoffwechsel beeinflussen.",
  },
  {
    cat: "Darm & Regeneration",
    q: "Gibt es einen Zusammenhang zwischen Darm, Entzündung und Regeneration?",
    a: "Ja. Forschung zu schwerer Erkrankung und Trauma zeigt: Chronische Entzündung, Immunsuppression und Katabolie (Muskelabbau) hängen eng mit dem Darm-Mikrobiom und der Darmbarriere zusammen. Eine 'ruhige', gut genährte Darmschleimhaut unterstützt eher Regeneration als dauerhaften Abbau.",
  },
  {
    cat: "Darm & Regeneration",
    q: "Ich fühle mich nach einer schweren Erkrankung oder Operation lange schwach und baue kaum Muskeln auf - hat das mit dem Darm zu tun?",
    a: "Nach größeren Belastungen (Operation, Unfall, schwere Infektion) gerät der Stoffwechsel oft in einen langanhaltenden 'Stressmodus': Der Körper baut eher ab (katabol) und spricht schlechter auf normale Ernährungsreize zum Muskelaufbau an (anabole Resistenz). Der Darm spielt dabei eine Schlüsselrolle: Wenn die Darmbarriere durchlässiger ist und das Mikrobiom gestört, kann das Entzündungssignale verstärken und die Regeneration bremsen.",
  },
  {
    cat: "Darm & Regeneration",
    q: "Kann eine darmfreundliche Ernährung dabei helfen, aus dem 'Abbau-Modus' herauszukommen?",
    a: "Indirekt, ja. Ernährung, die das Mikrobiom stabilisiert und die Darmbarriere unterstützt (ausreichend Protein, ballaststoffreiche und fermentierte Lebensmittel, gezielte Probiotika), kann helfen, Entzündungsniveau und Stoffwechselsignale günstiger zu gestalten. Das ist kein Wundermittel, aber ein wichtiger Baustein, um den Körper wieder in Richtung Aufbau und Erholung zu bringen.",
  },
  {
    cat: "Darm & Regeneration",
    q: "Was hat das mit Laktose und Probiotika zu tun?",
    a: "Wenn du durch Probiotika und angepasste Milchprodukte deine Laktosesymptome reduzierst, verbesserst du oft auch die Vielfalt und Funktion deines Mikrobioms, die Produktion kurzkettiger Fettsäuren (wichtige Energiequelle für die Darmzellen) und die Darmbarriere-Funktion. All das sind Faktoren, die in der Forschung mit besserer metabolischer Resilienz und geringerer chronischer Entzündung in Verbindung gebracht werden.",
  },
  {
    cat: "Darm & Regeneration",
    q: "Wie viel Protein brauche ich, wenn ich mich von einer schweren Belastung erhole?",
    a: "Nach größeren Belastungen (Operation, Unfall, lange Krankheit) braucht der Körper oft mehr Protein als im Alltag, um Muskeln und Gewebe wieder aufzubauen. Gleichzeitig kann der Stoffwechsel 'resistenter' auf diese Signale reagieren (anabole Resistenz). Eine individuelle Beratung (Arzt, Ernährungsberatung) ist hier sinnvoll; grob gilt aber: Regelmäßige, über den Tag verteilte Proteinquellen (inkl. gut verträglicher Milchprodukte) sind hilfreich - vorausgesetzt, der Darm ist ruhig.",
  },

  // -------- Praxis & Programm --------
  {
    cat: "Praxis & Programm",
    q: "Ich habe schon vieles probiert und nichts hat geholfen.",
    a: "Dann lohnt sich ein strukturierter Blick: Wurde die Diagnose gesichert (z. B. via H2-Atemtest)? Welche Probiotika-Stämme, Dosen und Dauer wurden verwendet? Gibt es weitere Faktoren (Reizdarm, Stress, Medikamente), die den Darm beeinflussen? Oft hilft eine Kombination aus gezielter Probiotika-Auswahl, langsamer Wiedereinführung von Laktose und allgemeiner darmfreundlicher Ernährung mehr als Einzelmaßnahmen.",
  },
  {
    cat: "Praxis & Programm",
    q: "Ist das hier nur ein weiterer 'Darm-Hype'?",
    a: "Der Darm ist tatsächlich ein sehr aktives Forschungsfeld - aber es geht nicht um Magie, sondern um nachweisbare Zusammenhänge zwischen Mikrobiom, Entzündung und Stoffwechsel. Probiotika bei Laktose sind vergleichsweise gut untersucht; die Verbindung zu Regeneration und Stoffwechsel ist ein logischer, evidenzgestützter nächster Schritt, keine esoterische Zusatzstory.",
  },
  {
    cat: "Praxis & Programm",
    q: "Wie kann ich meinen Darm gezielt für mehr Energie und bessere Regeneration nutzen?",
    a: "Wenn der Darm ruhiger arbeitet, kann sich der Körper besser auf Reparatur und Aufbau konzentrieren. Der LacLive-Ansatz zeigt, wie Ernährung, Probiotika und Alltagsgewohnheiten zusammenwirken, um aus einem dauerhaften Abbau-Modus (katabole Krise) wieder in Richtung Aufbau (anabole Phase) zu kommen.",
  },
  {
    cat: "Praxis & Programm",
    q: "Gibt es ein Programm, das Laktose-Thema und Stoffwechsel-Regeneration verbindet?",
    a: "Ja - der 12-Wochen-Plan von LacLive ist ein darmzentrierter Ansatz: Laktosemanagement plus Probiotika plus proteinreiche, entzündungsmodulierende Ernährung plus praktische Tipps für den Alltag nach Trauma, OP oder chronischer Belastung. Wichtig: Kein Ersatz für ärztliche Therapie, sondern ergänzende Ernährungsstrategie.",
  },
];
